import { TtsLocale } from '../../models/Base';

type DistractorPool = {
  pool: string[];
  mustContains: boolean; // if true, only use this pool when the answer is contained in the pool
  isPinyin: boolean;
  basicPool: boolean; // if ture, to return this pool not the number pool if no matched pool
};

type DistractorPools = DistractorPool[];

export const getDistractorPools = (locale: TtsLocale): DistractorPools => {
  const pools: DistractorPools = [
    {
      pool: Array.from('1234567890'),
      mustContains: true,
      isPinyin: false,
      basicPool: false,
    },
  ];

  switch (locale) {
    case TtsLocale.SA:
      pools.push({
        pool: Array.from('ابتثجحخدذرزسشصضطظعغفقكلمنهـوي'),
        mustContains: true,
        isPinyin: false,
        basicPool: true,
      });
      break;
    case TtsLocale.DE:
      pools.push(
        {
          pool: Array.from('AÄBCDEFGHIJKLMNOÖPQRSßTUVWXYÜZ'),
          mustContains: true,
          isPinyin: false,
          basicPool: false,
        },
        {
          pool: Array.from('aäbcdefghijklmnoöpqrsßtuvwxyüz'),
          mustContains: true,
          isPinyin: false,
          basicPool: true,
        },
      );
      break;
    case TtsLocale.AU:
    case TtsLocale.GB:
    case TtsLocale.US:
      // case TtsLocale.MY:
      pools.push(
        {
          pool: Array.from('ABCDEFGHIJKLMNOPQRSTUVWXYZ'),
          mustContains: true,
          isPinyin: false,
          basicPool: false,
        },
        {
          pool: Array.from('abcdefghijklmnopqrstuvwxyz'),
          mustContains: true,
          isPinyin: false,
          basicPool: true,
        },
      );
      break;
    case TtsLocale.ES:
      pools.push(
        {
          pool: Array.from('ABCDEFGHIJKLMNÑOPQRSTUVWXYZÁÉÍÓÚÜ'),
          mustContains: true,
          isPinyin: false,
          basicPool: false,
        },
        {
          pool: Array.from('abcdefghijklmnñopqrstuvwxyzáéíóúü'),
          mustContains: true,
          isPinyin: false,
          basicPool: true,
        },
      );
      break;
    case TtsLocale.FR:
      pools.push(
        {
          pool: Array.from('AÀÂÄBCÇDEÉÈÊËFGHIÎÏJKLMNOÔÖPQRSTUÙÛÜVWXYŸZ'),
          mustContains: true,
          isPinyin: false,
          basicPool: false,
        },
        {
          pool: Array.from('aàâäbcçdeéèêëfghiîïjklmnoôöpqrstuùûüvwxyÿz'),
          mustContains: true,
          isPinyin: false,
          basicPool: true,
        },
      );
      break;
    case TtsLocale.GR:
      pools.push(
        {
          pool: Array.from('ΑΒΓΔΕΖΗΘΙΚΛΜΝΞΟΠΡΣΤΥΦΧΨΩ'),
          mustContains: true,
          isPinyin: false,
          basicPool: false,
        },
        {
          pool: Array.from('αβγδεζηθικλμνξοπρστυφχψω'),
          mustContains: true,
          isPinyin: false,
          basicPool: true,
        },
      );
      break;
    case TtsLocale.IL:
      pools.push({
        pool: Array.from('אבגדהוזחטיכלמנסעפצקרשת'),
        mustContains: true,
        isPinyin: false,
        basicPool: true,
      });
      break;
    case TtsLocale.IT:
      pools.push(
        {
          pool: Array.from('ABCDEFGHIJKLMOPQRSTUVXYZÀÈÉÌÍÎÒÓÙÚ'),
          mustContains: true,
          isPinyin: false,
          basicPool: false,
        },
        {
          pool: Array.from('abcdefghijklmopqrstuvxyzàèéìíîòóùú'),
          mustContains: true,
          isPinyin: false,
          basicPool: true,
        },
      );
      break;
    case TtsLocale.JP:
      pools.push(
        {
          pool: Array.from(
            'ぁあぃいぅうぇえぉおかがきぎくぐけげこごさざしじすずせぜそぞただちぢっつづてでとどなにぬねのはばぱひびぴふぶぷへべぺほぼぽまみむめもゃやゅゆょよらりるれろゎわをんゔゕゖゝゞゟ',
          ),
          mustContains: false,
          isPinyin: false,
          basicPool: true,
        },
        {
          pool: Array.from(
            '日一国会人年大十二本中長出三同時政事自行社見月分議後前民生連五発間対上部東者党地合市業内相方四定今回新場金員九入選立開手米力学問高代明実円関決子動京全目表戦経通外最言氏現理調体化田当八六約主題下首意法不来作性的要用制治度務強気小七成期公持野協取都和統以機平総加山思家話世受区領多県続進正安設保改数記院女初北午指権心界支第産結百派点教報済書府活原先共得解名交資予川向際査勝面委告軍文反元重近千考判認画海参売利組知案道信策集在件団別物側任引使求所次水半品昨論計死官増係感特情投示変打男基私各始島直両朝革価式確村提運終挙果西勢減台広容必応演電歳住争談能無再位置企真流格有疑口過局少放税検藤町常校料沢裁状工建語球営空職証土与急止送援供可役構木割聞身費付施切由説転食比難防補車優夫研収断井何南石足違消境神番規術護展態導鮮備宅害配副算視条幹独警宮究育席輸訪楽起万着乗店述残想線率病農州武声質念待試族象銀域助労例衛然早張映限親額監環験追審商葉義伝働形景落欧担好退準賞訴辺造英被株頭技低毎医復仕去姿味負閣韓渡失移差衆個門写評課末守若脳極種美岡影命含福蔵量望松非撃佐核観察整段横融型白深字答夜製票況音申様財港識注呼渉達',
          ),
          mustContains: false,
          isPinyin: false,
          basicPool: false,
        },
      );
      break;
    case TtsLocale.KR:
      pools.push({
        pool: Array.from(
          '가갸거겨고교구규그기나냐너녀노뇨누뉴느니다댜더뎌도됴두듀드디라랴러려로료루류르리마먀머며모묘무뮤므미바뱌버벼보뵤부뷰브비사샤서셔소쇼수슈스시아야어여오요우유으이자쟈저져조죠주쥬즈지차챠처쳐초쵸추츄츠치카캬커켜코쿄쿠큐크키타탸터텨토툐투튜트티파퍄퍼펴포표푸퓨프피하햐허혀호효후휴흐히',
        ),
        mustContains: false,
        isPinyin: false,
        basicPool: true,
      });
      break;
    case TtsLocale.PT:
      pools.push(
        {
          pool: Array.from('AÁÃÂBCDEÉÊFGHIJKLMNOÓÕÔPQRSTUÚVWXYZÇ'),
          mustContains: true,
          isPinyin: false,
          basicPool: false,
        },
        {
          pool: Array.from('aáãâbcdeéêfghijklmnoóõôpqrstuúvwxyzç'),
          mustContains: true,
          isPinyin: false,
          basicPool: true,
        },
      );
      break;
    case TtsLocale.RU:
      pools.push(
        {
          pool: Array.from('АБВГДЕЁЖЗИЙКЛМНОПРСТУФХЦЧШЩЪЫЬЭЮЯ'),
          mustContains: true,
          isPinyin: false,
          basicPool: false,
        },
        {
          pool: Array.from('абвгдеёжзийклмнопрстуфхцчшщъыьэюя'),
          mustContains: true,
          isPinyin: false,
          basicPool: true,
        },
      );
      break;
    // case TtsLocale.TH:
    //   pools.push({
    //     pool: Array.from('กขฃคฅฆงจฉชซฌญฎฏฐฑฒณดตถทธนบปผฝพฟภมยรฤลฦวศษสหฬอฮ'),
    //     mustContains: true,
    //     isPinyin: false,
    //   });
    //   break;
    case TtsLocale.CN:
      pools.push(
        {
          pool: Array.from(
            '的一是了我不人在他有这个上们来到时大地为子中你说生国年着就那和要她出也得里后自以会家可下而过天去能对小多然于心学么之都好看起发当没成只如事把还用第样道想作种开美总从无情己面最女但现前些所同日手又行意动方期它头经长儿回位分爱老因很给名法间斯知世什两次使身者被高已亲其进此话常与活正感见明问力理尔点文几定本公特做外孩相西果走将月十实向声车全信重三机工物气每并别真打太新比才便夫再书部水像眼等体却加电主界门利海受听表德少克代员许先口由死安写性马光白或住难望教命花结乐色更拉东神记处让母父应直字场平报友关放至张认接告入笑内英军候民岁往何度山觉路带万男边风解叫任金快原吃妈变通师立象数四失满战远格士音轻目条呢病始达深完今提求清王化空业思切怎非找片罗钱吗语元喜曾离飞科言干流欢约各即指合反题必该论交终林请医晚制球决传画保读运及则房早院量苦火布品近坐产答星精视五连司巴奇管类未朋且婚台夜青北队久乎越观落尽形影红爸百令周吧识步希亚术留市半热送兴造谈容极随演收首根讲整式取照办强石古华拿计您装似足双妻尼转诉米称丽客南领节衣站黑刻统断福城故历惊脸选包紧争另建维绝树系伤示愿持千史谁准联妇纪基买志静阿诗独复痛消社算义竟确酒',
          ),
          mustContains: false,
          isPinyin: false,
          basicPool: true,
        },
        {
          pool: Array.from('āáǎàēéěèōóǒòīíǐìūúǔùabcdefghijklmnopqrstuvwxyz'),
          mustContains: true,
          isPinyin: true,
          basicPool: false,
        },
      );
      break;
    case TtsLocale.HK:
    case TtsLocale.TW:
      pools.push(
        {
          pool: Array.from(
            '的一是了我不人在他有這個上們來到時大地為子中你說生國年著就那和要她出也得裡后自以會家可下而過天去能對小多然於心學麼之都好看起發當沒成隻如事把還用第樣道想作種開美總從無情己面最女但現前些所同日手又行意動方期它頭經長兒回位分愛老因很給名法間斯知世什兩次使身者被高已親其進此話常與活正感見明問力理爾點文幾定本公特做外孩相西果走將月十實向聲車全信重三機工物氣每並別真打太新比才便夫再書部水像眼等體卻加電主界門利海受聽表德少克代員許先口由死安寫性馬光白或住難望教命花結樂色更拉東神記處讓母父應直字場平報友關放至張認接告入笑內英軍候民歲往何度山覺路帶萬男邊風解叫任金快原吃媽變通師立象數四失滿戰遠格士音輕目條呢病始達深完今提求清王化空業思切怎非找片羅錢嗎語元喜曾離飛科言干流歡約各即指合反題必該論交終林請醫晚制球決傳畫保讀運及則房早院量苦火布品近坐產答星精視五連司巴奇管類未朋且婚台夜青北隊久乎越觀落盡形影紅爸百令周吧識步希亞術留市半熱送興造談容極隨演收首根講整式取照辦強石古華拿計您裝似足雙妻尼轉訴米稱麗客南領節衣站黑刻統斷福城故歷驚臉選包緊爭另建維絕樹系傷示願持千史誰准聯婦紀基買志靜阿詩獨復痛消社算義竟確酒',
          ),
          mustContains: false,
          isPinyin: false,
          basicPool: true,
        },
        {
          pool: Array.from('āáǎàēéěèōóǒòīíǐìūúǔùabcdefghijklmnopqrstuvwxyz'),
          mustContains: true,
          isPinyin: true,
          basicPool: false,
        },
      );
      break;
  }

  return pools;
};
